import { Api } from '@/api';
import type { WorkflowEntity, WorkflowStatus } from '@/api/entity_types/workflow/Workflow';
import type { BadgeVariants } from '@/components/ui/badge';
import { computed } from 'vue';
import { toast } from 'vue-sonner';

type StatusProperties = {
  badgeVariant: BadgeVariants['variant'];
  content: 'Workflow Enabled' | 'Workflow Disabled';
  switch: 'Disable' | 'Enable';
};

const enabledStatusProperties: StatusProperties = {
  badgeVariant: 'green',
  content: 'Workflow Enabled',
  switch: 'Disable',
};

const disabledStatusProperties: StatusProperties = {
  badgeVariant: 'yellow',
  content: 'Workflow Disabled',
  switch: 'Enable',
};

export const useWorkflowStatus = (workflow: WorkflowEntity) => {
  const toggleStatus = async () => {
    const newStatus: WorkflowStatus = workflow.status === 'active' ? 'inactive' : 'active';
    const response = await Api.Workflows.updateWorkflow({ workflowId: workflow.id, params: { status: newStatus } });
    if (response.status === 'success') {
      toast.success(getStatusProperties(response.data.status).content);
      return response.data.status;
    } else {
      const description = response.messages.join(', ') || 'An error occurred while getting the workflows.';
      toast.error('Error Updating Workflow', { description });
    }
  };
  const isActive = () => workflow.status === 'active';

  const getStatusProperties = (status: WorkflowStatus) =>
    status === 'active' ? enabledStatusProperties : disabledStatusProperties;

  const statusProperties = computed(() => getStatusProperties(workflow.status));

  return { toggleStatus, isActive, statusProperties };
};
